// import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Jimp from 'jimp'

function Pdf(pattern:number) {

    const pxToMm = (px:number) => {
        return Math.floor(px/document.getElementById('myMm').offsetHeight);
      };
      
      const mmToPx = (mm:number) => {
        return document.getElementById('myMm').offsetHeight*mm;
      };
      
      const range = (start:number, end:number) => {
          return Array(end-start).join('0').split('0').map(function(val, id) {return id+start});
      };

    return new Promise((resolve,reject)=>{

        //PDFの長辺・短辺などの情報
        
        /**
         * PDFの長辺
         */
        const PDF_INNER_LONG_SIDE = 277

        /**
         * PDFの短辺
         */
        const PDF_INNER_SHORT_SIDE = 190

        /**
         * PDFは縦長か横長か
         */
        const pdfAngle=[1,2,3,4].indexOf(Number(pattern))!==-1?'portrait':'landscape'

        //html2canvas→jsPdfのコード
        const input = document.getElementById('pdf-content');
        /**
         * 画像の高さ（mm）
         */
        const inputHeightMm = pxToMm(input.offsetHeight);

        /**
         * 画像の横幅（mm）
         */
        const inputWidthMm = pxToMm(input.offsetWidth);

        /**
         * PDFの横幅（mm）
         */
        // const a4WidthMm = 210;

        /**
         * PDFの高さ（mm）
         */
        // const a4HeightMm = 297;
        
        /**
         * PDFのpaddingを除いた横幅（mm）
         */
        const a4InnerWidthMm = pdfAngle==='portrait' ? PDF_INNER_SHORT_SIDE : PDF_INNER_LONG_SIDE;

        /**
         * PDFのpaddingを除いた高さ（mm）
         */
        const a4InnerHeightMm = pdfAngle==='landscape' ? PDF_INNER_SHORT_SIDE : PDF_INNER_LONG_SIDE
        
        /**
         * PDFのpadding（mm）
         */;
        const a4Padding = 10;

        /**
         * PDFデータ
         */
        let pdf = new jsPDF({
            orientation: pdfAngle
        });

        /**
         * 画像(base64)を裁断し、PDFに貼り付ける関数
         */
        const pasteSplittedImageToPdf=(img:any,page:number)=>{
            return new Promise<void>((resolve,reject)=>{
    
                //画像データを裁断
                Jimp.read(img).then(data=>{

                    const scale=a4InnerHeightMm/a4InnerWidthMm//img.naturalWidth/mmToPx(a4InnerWidthMm)

                    /**
                     * これが最後のページかどうか
                     */
                    const isLastPage=inputWidthMm * a4InnerHeightMm * (page+1) / a4InnerWidthMm > inputHeightMm

                    data
                    //切り出し
                    .crop(
                        0,
                        data.bitmap.width*page*scale,//mmToPx(a4InnerHeightMm)*page*scale,
                        data.bitmap.width,//mmToPx(a4InnerWidthMm)*scale,

                        //切り出し範囲の下端が画像の範囲外であれば下端まで切り出し　そうでなければ通常どおり
                        isLastPage ? data.bitmap.height-data.bitmap.width*scale*(page) :data.bitmap.width*scale//mmToPx(a4InnerHeightMm)*scale
                    )
                    
                    //切り出した画像のbase64データをPDFに貼り付け
                    .getBase64(Jimp.MIME_PNG,(err,dataSplitted)=>{

                        //PDFのページを指定
                        pdf.setPage(page+1)

                        //指定したページに、裁断した画像を貼り付ける
                        pdf.addImage(
                            dataSplitted,
                            'PNG',
                            a4Padding,
                            a4Padding,
                            a4InnerWidthMm,
                            isLastPage ? (inputHeightMm - (page*inputWidthMm*a4InnerHeightMm/a4InnerWidthMm))*a4InnerWidthMm/inputWidthMm : a4InnerHeightMm
                        );

                        resolve()
                    })
                }).catch(err=>{
                    console.error(err)
                })
            })
        }

        /**
         * 帳票のimgとpdfを出力（Blob形式）
         */
        const setPdfUrl=()=>{

            //html2canvasで、帳票を画像化
            html2canvas(input)
            .then((canvas) => {
                /**
                 * 画像データ
                 */
                const imgData:string = canvas.toDataURL('image/png');

                /**
                 * 画像データを裁断し、PDFに貼り付ける関数を配列化したもの
                 * 「全タスクが終わったあと、次の処理に使う」という動きを実装するために使う
                 */
                let cutImgAndPasteToPdfTasks=[]

                /**
                 * ページ数
                 */
                const wholePageNum=Math.ceil((a4InnerWidthMm*inputHeightMm/inputWidthMm)/a4InnerHeightMm)

                //画像データを裁断し、PDFに貼り付ける関数
                //これを配列化
                for(let i=0;i<wholePageNum;i++){
                    if(i!==wholePageNum-1){
                        pdf.addPage()
                    }
                    cutImgAndPasteToPdfTasks.push(pasteSplittedImageToPdf(imgData,i))
                }

                //上記の関数を全部完了させたら
                Promise.all(cutImgAndPasteToPdfTasks).then(()=>{
                    /**
                     * 作成したPDFのarraybufferデータ
                     */
                    const renderString=pdf.output('arraybuffer')

                    /**
                     * 上記から、Blobデータを作成
                     * Blobのtypeを定義せず、ボタンを押すだけでダウンロードするようにするため、この方法を取る
                     */
                    const pdfBlob=new Blob([renderString])

                    /**
                     * imgデータとpdfデータを出力
                     */
                    resolve({
                        imgPath:imgData,
                        pdfPath:pdfBlob
                    })
                })
            });
        }
        
        return setPdfUrl()
    })
}


export {Pdf};